import { FC, SVGAttributes } from "react";

const SearchInputIcon: FC<SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="none" stroke="#999" strokeWidth="2" transform="translate(4 4)">
      <circle cx="6" cy="6" r="6" />
      <path d="M10 10L16 16" />
    </g>
  </svg>
);

export { SearchInputIcon };
